module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/bg_note_w2-aeb3acdd12bb81f94fccf18b6afdbcc9.png";